import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useRef } from 'react';
import Dropzone from 'react-dropzone';
import noop from 'lodash/noop';
import Button from '../button/Button';
const FilePicker = (props) => {
    const { displayMode = 'button', multiple = true, label = 'Select files', maxSize, onPick = noop, className = '', accept, children } = props, remainingProps = __rest(props, ["displayMode", "multiple", "label", "maxSize", "onPick", "className", "accept", "children"]);
    const dropzoneRef = useRef(null);
    const isFull = displayMode === 'full';
    const showButton = isFull || displayMode === 'button';
    const showDropzone = isFull || displayMode === 'dropzone';
    const handleDrop = useCallback((acceptedFiles, rejectedFiles) => {
        const hasImagesType = accept && Object.keys(accept).some(mimeType => mimeType.startsWith('image'));
        const files = hasImagesType
            ? acceptedFiles.map(file => Object.assign(file, { preview: URL.createObjectURL(file) }))
            : acceptedFiles;
        onPick(files, rejectedFiles);
    }, [onPick, accept]);
    const handleClick = () => { var _a; return (_a = dropzoneRef.current) === null || _a === void 0 ? void 0 : _a.open(); };
    return (_jsxs("div", Object.assign({ className: 'FilePicker' }, { children: [showButton && (_jsx(Button, Object.assign({ onClick: handleClick, className: className }, { children: label }))), _jsx(Dropzone, Object.assign({}, remainingProps, { onDrop: handleDrop, accept: accept, multiple: multiple, maxSize: maxSize, ref: dropzoneRef }, { children: ({ getRootProps, getInputProps, isDragActive }) => {
                    return (_jsxs("div", Object.assign({}, getRootProps(), { children: [_jsx("input", Object.assign({}, getInputProps())), showDropzone && children && children({ isDragActive })] })));
                } }))] })));
};
FilePicker.DISPLAY_MODE_BUTTON = 'button';
FilePicker.DISPLAY_MODE_DROPZONE = 'dropzone';
FilePicker.DISPLAY_MODE_FULL = 'full';
export default FilePicker;
